import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Grid } from "../../core/components/grid";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../../core/components/commonApp";
import { AppHelper } from "../../appHelper";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { KeyValuePair } from "../../commonInterfaces";
import React from "react";

export default class Branches extends React.Component<any, any>{
    private gridOptions: kendo.ui.GridOptions;
    private standardButtons: Array<ToolBarStandardButton> = [
        { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
        { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true },
        { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true }
    ];

    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
        this.initApp();

    }

    private initApp = async () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Value",
                    title: Helper.getTranslation("Standard.Bezeichnung"),
                }
            ]
        };
        await this.loadData();
    }

    private loadData = async () => {
        const { Code, Data } = await HTTPService.get<JsonResultClass>("Branche/GetAll");
        if (Code == 0) {
            this.setState({ data: Data })
        }
    }

    private openSheet = (names: [], isNew: boolean) => {
        let metaData: Metadata = {
            tabs: [
                {
                    title: "",
                    regions: [
                        {
                            title: "",
                            renderHeader: false,
                            fields: [
                                {
                                    model: "entity.Names",
                                    name: "Translations",
                                    type: "dynamic",
                                    visible: true,
                                    readOnly: "entity.ReadOnly",
                                    labelAndControlCombined: true,
                                    moduleName: "app/editIndividualFields/editTranslations",
                                    maxLenght: 33,
                                    columnName: Helper.getTranslation("Standard.Name"),
                                    invisibleLanguages: isNew ? [] : [0]
                                } as any
                            ]
                        }
                    ]
                }
            ],
            menuDataSource: [{
                type: "save"
            }]
        };

        const props: BrancheProps = {
            context: {},
            title: "",
            entity: {
                IsNew: isNew,
                IsWatchable: false,
                IsWatched: false,
                Names: names,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: {}
            },
            metadata: metaData,
            dataSources: {},
            isWindow: true,
            validate: (names) => {
                debugger;
                const german = names.find(f => f.Key == 0);
                if (!Helper.hasValue(german) || Helper.isNullOrEmpty(german.Value)) {
                    NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.Branche.OneGerman"));
                    return false;
                }
                const dublicate = this.state.data.find(f => f.Key.toLowerCase() == german.Value.toLowerCase())
                if (Helper.hasValue(dublicate) && isNew) {
                    NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.Branche.AlreadyExits").replace("{x}", german.Value));
                    return false;
                } else {
                    return true
                }
            },
            delete: this.delete
        };
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, this.loadData);

        sheet.show(() => {
            sheet.mountContent(BrancheSheet, props);
        });
    }

    private delete = async (branche: string) => {
        const { Code, Message } = await HTTPService.get<JsonResultClass>(`Branche/Delete?branche=${branche}`);
        if (Code != 0)
            NotificationHelper.showErrorMessage(Message)
        else
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"))
        await this.loadData()
        return Code == 0;
    }

    private onClickStandardButton = async (type: ToolBarStandardButtonType, item) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.openSheet([], true);
                break;
            case ToolBarStandardButtonType.EDIT:
                const { Code, Data } = await HTTPService.get<JsonResultClass>(`Branche/GetTranslations?branche=${item.Key}`);
                if (Code == 0) {
                    this.openSheet(Data, false)
                }
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
                if (isOk)
                    this.delete(item.Key)
                break;
        }
    }

    render() {
        return (
            <div className="flex-container" style={{ height: "360px" }} >
                <Grid
                    data={this.state.data}
                    options={this.gridOptions}
                    id={`branches`}
                    standardButtons={this.standardButtons}
                    onClickStandardButton={this.onClickStandardButton}
                />
            </div>
        );
    }
}

class BrancheSheet extends React.Component<BrancheProps, any>{
    private common = new AppHelper();
    constructor(props) {
        super(props)
        this.common.enableHooks = true;
        this.common.init(this);
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async () => {
        const isOk = this.props.validate(this.props.entity.Names)
        if (isOk) {
            const url = this.props.entity.IsNew ? 'Branche/Save' : 'Branche/Update'
            const { Code, Message } = await HTTPService.post<JsonResultClass>(url, { Names: this.props.entity.Names })
            if (Code == 0) {
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"))
                
            } else {
                NotificationHelper.showErrorMessage(Message)
            }
            this.common.handlePostSave(Code == 0, Code == 0);
        } 
    }

    //

    componentDidMount() {
        if (!this.props.entity.IsNew)
            this.common.updateSheetTitle(Helper.getTranslation("WebSMS.GeneralSettings.Branche.TranslationsFor").replace("{x}", this.props.entity.Names.find(f => f.Key == 0).Value))
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface BrancheProps extends AppBaseProps {
    entity: BrancheEntity;
    validate: (names: KeyValuePair<number, string>[]) => boolean;
    delete: (branche: string) => Promise<boolean>;
}

interface BrancheEntity extends Entity {
    Names: KeyValuePair<number, string>[]
}